import React, { FC, useState } from 'react';
import ProfileConfiguration from '../../components/ProfileConfiguration';

import withErrorBoundary from '../../hoc/ErrorBoundary';

interface Props {
  profileSections: any;
  setProfileSections: (sections: any) => void;
  showToastMessage: any;
  visitorType: string;
}

const ProfileConfigurationContainer: FC<Props> = (props: any) => {
  const [sections, setSections] = useState(props.profileSections);
  return (
    <ProfileConfiguration
      sections={sections}
      setSections={setSections}
      profileSections={props.profileSections}
      setProfileSections={props.setProfileSections}
      showConfigMenu={props.showConfigMenu}
      showToastMessage={props.showToastMessage}
      visitorType={props.visitorType}
    />
  );
};

export default withErrorBoundary(ProfileConfigurationContainer);
